import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, renderSlot as _renderSlot, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "No", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}, "Yes", -1)
const _hoisted_3 = { class: "border-bottom mb-3" }
const _hoisted_4 = { class: "mb-3 row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "auditorName",
  class: "col-sm-3 col-form-label"
}, "Audit Name:", -1)
const _hoisted_6 = { class: "col-sm-9" }
const _hoisted_7 = { class: "mb-3 row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledSelect",
  class: "col-sm-3 col-form-label"
}, "Agency:", -1)
const _hoisted_9 = { class: "col-sm-9" }
const _hoisted_10 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_11 = { class: "mb-3 row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledTextInput",
  class: "col-sm-3 col-form-label"
}, "Start Date:", -1)
const _hoisted_13 = { class: "col-sm-9" }
const _hoisted_14 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_15 = { class: "mb-3 row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledTextInput",
  class: "col-sm-3 col-form-label"
}, "Planned End Date:", -1)
const _hoisted_17 = { class: "col-sm-9" }
const _hoisted_18 = { class: "mb-3 row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledTextInput",
  class: "col-sm-3 col-form-label"
}, "Audit to Cover:", -1)
const _hoisted_20 = { class: "col-sm-9" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "startMonth",
  class: "col-form-label"
}, "Start Month:", -1)
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_25 = { class: "col" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "endMonth",
  class: "col-form-label"
}, "End Month:", -1)
const _hoisted_27 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_28 = { class: "mb-4 row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  for: "agencyContactRole",
  class: "col-sm-3 col-form-label"
}, "Agency Contact:", -1)
const _hoisted_30 = { class: "col-sm-9" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "N/A", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_34 = { class: "mb-3 row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "auditorName",
  class: "col-sm-3 col-form-label"
}, "Auditor Name:", -1)
const _hoisted_36 = { class: "col-sm-9" }
const _hoisted_37 = { class: "mb-3 row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "disabledTextInput",
  class: "col-sm-3 col-form-label"
}, "Auditor Email Address:", -1)
const _hoisted_39 = { class: "col-sm-9" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Cancel"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary",
    type: "submit"
  }, "Save")
], -1)
const _hoisted_41 = { class: "audits-grid" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search pe-1" }, null, -1)
const _hoisted_43 = {
  key: 1,
  class: "ms-2 filter-description"
}
const _hoisted_44 = ["href"]
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = ["href"]
const _hoisted_51 = { key: 1 }
const _hoisted_52 = ["href"]
const _hoisted_53 = { key: 1 }

import { ref, reactive, computed } from "vue";

import BTable from "./BTable/BTable.vue";
import BTableHeader from "./BTable/BTableHeader.vue";
import { BTableColumn, BTableOptions } from "./BTable/BTable.types";
import Datepicker from "@vuepic/vue-datepicker";
import Multiselect from "@vueform/multiselect";
import {
    describeFilters,
    BFilterOptions,
} from "./BFilterEditor/BFilterEditor.types";
import BFilterModal from "./BFilterEditor/BFilterModal.vue";
import { useOriStore } from "@/stores/oriStore";

import InformationModal from "./Misc/InformationModal.vue";
import SystemAlerts from "./Misc/SystemAlerts.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import { SelectItem, UploadType } from "@/types";
import { useAuditStore } from "@/stores/auditStore";
import type { Audit } from "../audit.types";
import { useFormValidation } from "../validation";
import TextInput from "./Fields/TextInput.vue";
import { object, string, date } from "yup";
import { useAgencyContactsStore } from "@/stores/agencyContactsStore";
import { debounce } from "vue-debounce";

const dateFormat = "yyyy-MM-dd";


export default /*#__PURE__*/_defineComponent({
  __name: 'Audits',
  props: {
    title: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props;

var updateData = debounce(() => getData(), "15000ms");

const audit = ref<Audit>({} as Audit);

const isShowCreateEditor = ref(false);

const startMonth = ref();
const endMonth = ref();

const hasAppliedFilters = ref(false);
const auditStore = useAuditStore();
const agencyContactsStore = useAgencyContactsStore();

const schema = object<Audit>({
    auditName: string().required().label("Audit Name"),
    agency: string().required().label("Agency"),
    startDate: date().required().label("Start Date"),
    startMonth: date().required().label("Start Month"),
    agencyContactRole: string().required().label("Agency Contact"),
    endMonth: date()
        .required()
        .label("End Month")
        .when("startMonth", (startMonth, schema) => {
            console.log("date", audit.value.startMonth);
            if (audit.value.startMonth) {
                const dayAfter = new Date(
                    audit.value.startMonth.getTime() + 86400000
                );

                console.log(
                    "date",
                    audit.value.startMonth,
                    audit.value.endMonth,
                    dayAfter
                );
                return schema.min(
                    dayAfter,
                    "End month has to be after than start month"
                );
            }

            return schema;
        }),
    auditorName: string().required().label("Auditor Name"),
    auditEmailAddress: string().email().label("Audit Email Address"),
});

const oriStore = useOriStore();
oriStore.dataset = UploadType.nibrs;

const agencies = computed(() => {
    const values = oriStore.oris;
    let list = values.map(
        (m) =>
            ({
                label: `${m.ori} - ${m.agency}`,
                value: m.ori,
            } as SelectItem)
    );

    return list;
});

const columns = reactive<BTableColumn[]>([
    {
        key: "auditName",
        text: "Audit Name",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["auditName"],
    },
    {
        key: "agencyName",
        text: "Agency Name",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["agencyName"],
    },
    {
        key: "startDate",
        text: "Start Date",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item.startDate,
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item["status"],
    },

    {
        key: "incidents",
        text: "Documents requested",
        sortable: false,
        class: (item) => ["text-center"],
        columnClass: ["text-center align-top"],
        value: (item) => item["documents"],
    },
    {
        key: "documentsAccepted",
        text: "Documents accepted",
        sortable: false,
        class: (item) => ["text-center"],
        columnClass: ["text-center align-top"],
        value: (item) => item["documentsAccepted"],
    },

    {
        key: "incidents",
        text: "Incidents",
        sortable: false,
        class: (item) => ["text-center"],
        columnClass: ["text-center align-top"],
        value: (item) => item["incidents"],
    },
    {
        key: "uploadedNarratives",
        text: "Uploaded Narratives",
        class: (item) => ["text-center"],
        columnClass: ["text-center"],
        sortable: false,
        value: (item) => item["uploadedNarratives"],
    },
    {
        key: "completedReviews",
        text: "Completed Reviews",
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
        sortable: false,
        value: (item) => item["completedReviews"],
    },
    {
        key: "passedReviews",
        text: "Passed Reviews",
        class: (item) => ["text-center"],
        columnClass: ["text-center"],
        sortable: true,
        value: (item) => item["passedReviews"],
    },
    {
        key: "reportFileId",
        text: "Report File",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-wrap"],
        value: (item) => item["reportFileId"],
    },
]);

const showCreateEditor = async function () {
    audit.value = {} as Audit;
    isShowCreateEditor.value = true;
    let user = await auditStore.getCurrentUser();
    audit.value.auditorEmailAddress = user.email;
    audit.value.agencyContactRole = "0";
    audit.value.auditorName = `${user.firstName} ${user.lastName}`.trim();
};
const hideCreateEditor = function () {
    isShowCreateEditor.value = false;
};

const isShowFilterEditor = ref(false);
const showFilterEditor = function () {
    isShowFilterEditor.value = true;
};

const handleOptionChange = async function (options: BTableOptions) {
    auditStore.tableOptions = options;
    await getData();
};
const handleDismiss = function () {
    isShowFilterEditor.value = false;
};
const resetFilters = async function () {
    if (auditStore.filterOptions != null) {
        auditStore.filterOptions.filters = [];
        await getData();
    }
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = false;
};
const applyFilters = async function (newFilterOptions: BFilterOptions) {
    auditStore.filterOptions = newFilterOptions;
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = auditStore.filterOptions.filters.length > 0;
    await getData();
};

const filtersDescription = computed(() => {
    if (auditStore.filterOptions == null) {
        return "";
    }
    return describeFilters(
        auditStore.filterOptions.filters,
        auditStore.filterableFields
    );
});

const getData = async function () {
    await auditStore.list();
    await updateData();
};

const canAdd = computed(() => props.createAudits);

const canDelete = function (): boolean {
    return props.runAudits;
};

const { handleSubmit, errors } = useFormValidation();

const createAudit = async () => {
    if (await handleSubmit(schema, audit.value)) {
        await auditStore.create(audit.value);
        await getData();
        await hideCreateEditor();
        audit.value = {} as Audit;
    }
};

;(
  ([__temp,__restore] = _withAsyncContext(() => getData())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => agencyContactsStore.list())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InformationModal, {
      title: "Delete",
      key: "confirmDialog",
      ref: "confirmDialog",
      "show-footer": true,
      className: "confirm",
      onDismiss: hideCreateEditor
    }, {
      footer: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createTextVNode(" Are You Sure? ")
      ]),
      _: 1
    }, 512),
    _createVNode(InformationModal, {
      title: "Create Audit",
      "show-modal": isShowCreateEditor.value,
      ref: "createDialog",
      onDismiss: hideCreateEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(createAudit, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(TextInput, {
                  name: "auditorName",
                  type: "text",
                  modelValue: audit.value.auditName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((audit.value.auditName) = $event)),
                  error: _unref(errors).auditName
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Multiselect), {
                  modelValue: audit.value.agency,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((audit.value.agency) = $event)),
                  options: agencies.value,
                  multiple: false,
                  "close-on-select": true,
                  class: _normalizeClass({ 'is-invalid': !!_unref(errors).agency}),
                  label: 'label',
                  searchable: true,
                  "filter-results": true,
                  strict: false,
                  submit: false,
                  "native-support": true
                }, null, 8, ["modelValue", "options", "class"]),
                (_unref(errors).agency)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(errors).agency), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(Datepicker), {
                  format: dateFormat,
                  modelValue: audit.value.startDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((audit.value.startDate) = $event)),
                  clearable: false,
                  class: _normalizeClass({ 'is-invalid': !!_unref(errors).startDate}),
                  "enable-time-picker": false,
                  "input-class-name": !!_unref(errors).startDate?'form-control is-invalid':'form-control'
                }, null, 8, ["modelValue", "class", "input-class-name"]),
                (_unref(errors).startDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(errors).startDate), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_unref(Datepicker), {
                  format: dateFormat,
                  modelValue: audit.value.plannedEndDate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((audit.value.plannedEndDate) = $event)),
                  clearable: false,
                  "enable-time-picker": false,
                  "input-class-name": !!_unref(errors).plannedEndDate?'form-control is-invalid':'form-control'
                }, null, 8, ["modelValue", "input-class-name"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_unref(Datepicker), {
                      modelValue: startMonth.value,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((startMonth).value = $event)),
                        _cache[5] || (_cache[5] = ($event: any) => (audit.value.startMonth=new Date(startMonth.value.year, startMonth.value.month, 1)))
                      ],
                      clearable: false,
                      "enable-time-picker": false,
                      class: _normalizeClass({ 'is-invalid': !!_unref(errors).startMonth}),
                      "month-picker": true,
                      format: "MM-yyyy",
                      "input-class-name": !!_unref(errors).startMonth?'form-control is-invalid':'form-control'
                    }, null, 8, ["modelValue", "class", "input-class-name"]),
                    (_unref(errors).startMonth)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(errors).startMonth), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_unref(Datepicker), {
                      modelValue: endMonth.value,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((endMonth).value = $event)),
                        _cache[7] || (_cache[7] = ($event: any) => (audit.value.endMonth=new Date(endMonth.value.year, endMonth.value.month, 0)))
                      ],
                      clearable: false,
                      "month-picker": true,
                      format: "MM-yyyy",
                      class: _normalizeClass({ 'is-invalid': !!_unref(errors).endMonth}),
                      "enable-time-picker": false,
                      "input-class-name": !!_unref(errors).endMonth?'form-control is-invalid':'form-control'
                    }, null, 8, ["modelValue", "class", "input-class-name"]),
                    (_unref(errors).endMonth)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(errors).endMonth), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("select", {
                  id: "agencyContactRole",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((audit.value.agencyContactRole) = $event)),
                  class: "form-select"
                }, [
                  _hoisted_31,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agencyContactsStore).items, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.value,
                      key: item.value
                    }, _toDisplayString(item.label), 9, _hoisted_32))
                  }), 128))
                ], 512), [
                  [_vModelSelect, audit.value.agencyContactRole]
                ]),
                (_unref(errors).agencyContactRole)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_unref(errors).agencyContactRole), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _createVNode(TextInput, {
                  name: "auditorName",
                  type: "text",
                  modelValue: audit.value.auditorName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((audit.value.auditorName) = $event)),
                  error: _unref(errors).auditorName
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _createVNode(TextInput, {
                  name: "auditorName",
                  type: "text",
                  modelValue: audit.value.auditorEmailAddress,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((audit.value.auditorEmailAddress) = $event)),
                  error: _unref(errors).auditorEmailAddress
                }, null, 8, ["modelValue", "error"])
              ])
            ])
          ]),
          _hoisted_40
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(SystemAlerts),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(BFilterModal, {
        isShowFilterEditor: isShowFilterEditor.value,
        filterOptions: _unref(auditStore).filterOptions,
        filterableFields: _unref(auditStore).filterableFields,
        onFilterChanged: applyFilters,
        onDismissModal: handleDismiss
      }, null, 8, ["isShowFilterEditor", "filterOptions", "filterableFields"]),
      _createVNode(BTableHeader, {
        value: _unref(auditStore).tableOptions,
        onOptionChange: handleOptionChange,
        "header-slot-class": "b-header-slot w-100 position-relative"
      }, {
        default: _withCtx(() => [
          (canAdd.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _withModifiers(showCreateEditor, ["prevent"]),
                class: "btn btn-primary me-2"
              }, " Create Audit "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _withModifiers(showFilterEditor, ["prevent"]),
            class: "btn btn-primary"
          }, [
            _hoisted_42,
            _createTextVNode(" Filter ")
          ]),
          _renderSlot(_ctx.$slots, "header.toolbar"),
          (hasAppliedFilters.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(filtersDescription.value), 1))
            : _createCommentVNode("", true),
          (hasAppliedFilters.value)
            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn-close",
                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (resetFilters()), ["prevent"]))
              }, null, 512)), [
                [_directive_tooltip, 'Remove all currently applied filters.']
              ])
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["value"]),
      _createVNode(BTable, {
        items: _unref(auditStore).items,
        columns: columns,
        caption: 'List of audits',
        value: _unref(auditStore).tableOptions,
        onOptionChange: handleOptionChange
      }, {
        "cell.auditName": _withCtx(({ item }) => [
          (item.status=='In Progress'|| item.status=='Closed' || item.status=='New')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
                href: `AgencyCommunicationAuditsDetails.aspx?id=${item.id}`
              }, _toDisplayString(item["auditName"]), 9, _hoisted_44))
            : (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(item["auditName"]), 1))
        ]),
        "header.documentsAccepted": _withCtx(({ item }) => [
          _createTextVNode(" (% of requested) ")
        ]),
        "cell.documentsAccepted": _withCtx(({ item }) => [
          (item.documentsAccepted)
            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(item.documentsAccepted) + " (" + _toDisplayString(item.documentsAcceptedPercentage) + "%) ", 1))
            : _createCommentVNode("", true)
        ]),
        "header.uploadedNarratives": _withCtx(({ item }) => [
          _createTextVNode(" (% of incidents) ")
        ]),
        "cell.uploadedNarratives": _withCtx(({ item }) => [
          (item.uploadedNarratives)
            ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(item.uploadedNarratives) + " (" + _toDisplayString(item.uploadedNarrativesPercentage) + "%) ", 1))
            : _createCommentVNode("", true)
        ]),
        "header.completedReviews": _withCtx(({ item }) => [
          _createTextVNode(" (% of incidents) ")
        ]),
        "cell.completedReviews": _withCtx(({ item }) => [
          (item.completedReviews)
            ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(item.completedReviews) + " (" + _toDisplayString(item.completedReviewsPercentage) + "%) ", 1))
            : _createCommentVNode("", true)
        ]),
        "header.passedReviews": _withCtx(({ item }) => [
          _createTextVNode(" (% of completed reviews) ")
        ]),
        "cell.passedReviews": _withCtx(({ item }) => [
          (item.passedReviews)
            ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(item.passedReviews) + " (" + _toDisplayString(item.passedReviewsPercentage) + "%) ", 1))
            : _createCommentVNode("", true)
        ]),
        "cell.status": _withCtx(({ item }) => [
          (item.status=='Failed')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showFailedDialog && _ctx.showFailedDialog(...args))),
                href: `AgencyCommunicationAuditsDetails.aspx?id=${item.id}`
              }, _toDisplayString(item["status"]), 9, _hoisted_50))
            : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(item["status"]), 1))
        ]),
        "cell.reportFileId": _withCtx(({ item }) => [
          (item.reportFileId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `api/v1/audit/file/${item.reportFileId}`,
                class: "btn btn-sm btn-secondary"
              }, "View Report", 8, _hoisted_52))
            : (_openBlock(), _createElementBlock("span", _hoisted_53))
        ]),
        _: 1
      }, 8, ["items", "columns", "value"]),
      _createVNode(BTableHeader, {
        value: _unref(auditStore).tableOptions,
        onOptionChange: handleOptionChange,
        "header-slot-class": "b-header-slot w-100"
      }, null, 8, ["value"])
    ])
  ], 64))
}
}

})